import i18next from 'i18next';

let mapUnit = {};
let sensorSubTypeToTitlePlural = {};
let sensorSubTypeToTitle = {};

const illegalNameChars = /[\\/=+&|^*]/g;

const sensorSubTypes = ['i', 'o', 's', 'bi', 'bo', 'RACK', 'RACKDEVICE', 'ROOM', 'AISLE', 'DC'];

const GROUP_TYPES = ["DC", "ROOM", "AISLE", "RACK", "RACKDEVICE"];

let switchStates = {};

function init (t, mapUnitFromApi) {
    // These come from the translation api, and are served from ESensorUnit / TopicUpdater
    mapUnit = mapUnitFromApi;
    switchStates[0] = t("switch.off");
    switchStates[1] = t("switch.on");
    switchStates["TRUE"] = t("switch.on");
    switchStates["FALSE"] = t("switch.on");
    switchStates["MIXED"] = t("switch.mixed");

    for (let i in sensorSubTypes) {
        const key = sensorSubTypes[i];
        sensorSubTypeToTitlePlural[key] = t("sensor_sub_types." + key.toLowerCase() + "_plur");
        sensorSubTypeToTitle[key] = t("sensor_sub_types." + key.toLowerCase());
    }
}

const sensorPortRegex = /sensor\/([^\/]+)\/([^\/]+)\/([^\/]+)/;
const groupTypeRegex = /group\/([^\/]+)\/([^\/]+)/;
const namedRootRegex = /(sensor\/[^\/]+|group\/[^\/]+)/;
const sensorTypeRegex = /sensor\/[^\/]+\/([^\/]+)\/.+/;
const thrTypeRegex = /TYPE=(.*)/;

function getNamedRoot(topic) {
    const matches = namedRootRegex.exec(topic);
    if (matches) {
        return matches[1];
    }
    return null;
}

/**
 * Return the type of sensor / group type to expect for this path.
 * @param p om7sense push instance
 * @param path the topic path in question
 * @param data optionally pre-fetched data item at path
 * @returns for sensor/* paths, it will return i for inlet, o for outlet, .... For groups it will return the group type, if the data is in the DS
 */
function getTypeFromPath(p, path, data) {
    const sensorTypeMatch = sensorTypeRegex.exec(path);
    if (sensorTypeMatch) {
        return sensorTypeMatch[1];
    }

    if (path.indexOf("group/") === 0) {
        let dataItem = data || p.getPath(path);
        if (dataItem) {
            return dataItem.type;
        }
    }
}

function getUnitFromPath(p, t, path) {
    const sensorPortMatch = sensorPortRegex.exec(path);
    if (sensorPortMatch && sensorPortMatch[2] === "s") {
        // Special case: it is a rule path and encodes the type
        const ruleMatch = thrTypeRegex.exec(sensorPortMatch[3]);
        if (ruleMatch) {
            return [mapUnit[ruleMatch[1]], ruleMatch[1]];
        }
        const portInfo = p.getPath(sensorPortMatch[0]);
        if (portInfo?.unit) {
            return [t("sensor_units." + portInfo.unit), portInfo.type];
        }
    }

    const valueTopic = path.split("/").pop();

    return [mapUnit[valueTopic], valueTopic];
}

function _formatVal(topicName, numberVal, noUnit, unit) {
    let res;
    switch (topicName) {
    case "Current":
    case "L1":
    case "L2":
    case "L3":
        res = numberVal.toFixed(2);
        break;
    default:
        res = numberVal.toFixed(1);
        break;
    }

    if (!noUnit) {
        if (mapUnit[topicName]) {
            return res + " " + mapUnit[topicName];
        } else if (unit) {
            return res + " " + mapUnit[unit];
        }
    }

    return res;    
}

function formatPlainValue(topicName, value, noUnit) {
    if (typeof value !== "number") {
        return _formatVal(topicName, +value, noUnit);
    } else {
        return _formatVal(topicName, value, noUnit);
    }
}

function formatValue(topicName, t, noUnit, unit) {
    if (!t || t.v === undefined) {
        return "-";
    }

    if (topicName === "switch") {
        return switchStates[t.v];
    }

    let numberVal;

    if (typeof t.v !== "number") {
        numberVal = +t.v;
    } else {
        numberVal = t.v;
    }

    return _formatVal(topicName, numberVal, noUnit, unit ? unit : t.unit);
}

const MAP_STATE_TO_CLASSNAME = {
    "DEGRADED": "critical",
    "EMPTY": "warning",
    "STOPPED": "warning",
    "MISCONFIGURED": "critical",
    "CONNECTING": "warning",
    "CANNOT_CONNECT_TRANSIENT": "warning",
    "NOT_AVAILABLE": "critical",
    "SHUTDOWN": "critical",
    "INITIALIZING": "good",
    "REINITIALIZING": "good",
    "STARTING": "good",
    "AUTHENTICATION_FAILED": "critical",
    "SOURCE_DISCONNECTED": "critical",
    "LICENSE_INSUFFICIENT": "critical",
    "NOT_YET_STARTED": "warning",
    "RUNNING": "good"
};

export {
    init,
    mapUnit,
    sensorSubTypeToTitle,
    sensorSubTypeToTitlePlural,
    sensorPortRegex,
    groupTypeRegex,
    getNamedRoot,
    getUnitFromPath,
    formatValue,
    getTypeFromPath,
    formatPlainValue,
    MAP_STATE_TO_CLASSNAME,
    GROUP_TYPES,
    illegalNameChars
};

